import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Avatar, Divider, Radio, Space, Table} from "antd";
import {Link} from "react-router-dom";
import {divide1toPct, handleRank, setKey} from "../util/util";
import Icon from "./Icon";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";

export default (prop) => {

    const {t} = useTranslation()
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])

    const columns = [
        {
            key: 'rank',
            dataIndex: 'rank',
            title: t('rank'),
            render: (rank) => <b>{rank}</b>,
            align: 'center',
        },
        {
            key: 'player',
            dataIndex: 'player',
            title: t('players'),
            render: (_, p) =>
                <Link to={`/player/${p.handle}`} >
                <Space>
                {
                    p.pfp > 0 ? <Avatar src={`https://www.aslucky.club/file/touhou/pfp/${p.handle}.png?r=${p.pfp}`} shape="square" size={32} icon={<UserOutlined />} />
                        : <Avatar shape="square" size={32} icon={<UserOutlined />} />
                }
                <span>{p.clanTag ? `<${p.clanTag}>` : ''}{p.name}</span>
            </Space>
                </Link>,
            align: 'left',
            width: 300
        },
        {
            key: 'mmr',
            dataIndex: 'mmr',
            title: t('points'),
            render: (mmr, p) => <div style={{ position: "relative" }}>
                <b>{mmr}</b>
                <b style={{ color: p.color, fontSize: "20px", position: "absolute", top: '-6px', right: "6px" }}>{p.flag}</b>
            </div>,
            align: 'center',
        },
        {
            key: 'wins',
            dataIndex: 'wins',
            title: t('wins'),
            align: 'center',
        },
        {
            key: 'losses',
            dataIndex: 'losses',
            title: t('losses'),
            align: 'center',
        },
        {
            key: 'winPercentage',
            dataIndex: 'winPercentage',
            title: t('heroListTitle.winPercentage'),
            render: (_, p) => <span>{divide1toPct(p.wins,p.wins + p.losses)}%</span>,
            align: 'center',
        },
    ]

    useEffect(() => {
        setLoading(true)
        axios.get(`player/heroRank/${prop.heroId}`).then(data => {
            setKey(data, 'handle')
            setData(data)
            handleRank(data)
            setLoading(false)
        })
    }, [])

    return <Space direction={'vertical'} size={30}>


        <Table size={'small'} style={{ width: "560px" }} columns={columns} pagination={false} dataSource={data} loading={loading}/>
    </Space>
}
